import fetchJSON from '@api/api_helper';
import { processAnnotationResponse } from '@api/helper';

const getUrl = (attachmentKey) => `/api/v4/attachments/${attachmentKey}/annotations`;

export const get = (options, updateFetchControllers) => (
  fetchJSON(getUrl(options.attachmentKey), options, updateFetchControllers)
    .then((response) => processAnnotationResponse(response))
);
